import { isUploadAvatarData } from '@anm/components/form/UserAvatarInput';
import { UserFormFields } from '@anm/components/user/UserForm';

import useUpdateUserHandler from '../../../hooks/user/useUpdateUserHandler';

export const useAutoSave = () => {
  const updateUser = useUpdateUserHandler();

  const handleAutoSave = ({ avatar, ...otherFields }: UserFormFields) => {
    updateUser({
      ...(avatar && isUploadAvatarData(avatar) && { avatar: avatar.file }),
      ...otherFields
    });
  };

  return { handleAutoSave };
};
